// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as App$OrcaPaymentPage from "./App.bs.js";
import * as Sentry$OrcaPaymentPage from "./hyper-log-catcher/Sentry.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./hyper-log-catcher/ErrorBoundary.bs.js";

require("tailwindcss/tailwind.css")
;

import './index.css'
;

Sentry$OrcaPaymentPage.initiateSentry(__SDK_CONFIG__.sentryDSN);

let container = document.querySelector("#app");

let app;

if (container == null) {
  app = undefined;
} else {
  let root = Client.createRoot(container);
  root.render(JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Jotai.Provider, {
        children: JsxRuntime.jsx(ErrorBoundary$OrcaPaymentPage.make, {
          children: JsxRuntime.jsx(App$OrcaPaymentPage.make, {}),
          level: "Top",
          componentName: "App"
        })
      }),
      className: "h-auto flex flex-col"
    }),
    className: "h-auto flex flex-col "
  }));
  app = undefined;
}

export {
  app,
}
/*  Not a pure module */
